module.exports = __webpack_public_path__ + "img/angel-2.3d285b09.jpg";